import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import GHref from 'tennders-market/common/components/element/GHref'
import MRouteInstructions from 'tennders-transactions/modal/RouteInstructions'
import useFlagIcon from 'tennders-market/common/components/row/useFlagIcon'
import 'swiper/css'
import IconSeeNote from '../../../icons/icon-see-note.svg'

const Route = () => {
  const { t } = useTranslation()
  const { transaction } = useTransaction()
  const [pickupRoutes, setpickupRoutes] = useState([])
  const { showRouteOf, selectedOffer } = useOffer()
  const sliderRef = React.useRef(null)
  const [deliveryRoutes, setdeliveryRoutes] = useState([])
  // todo: figure out what to do with item
  // const [item, setitem] = useState(null)
  const [selectedStop, setselectedStop] = useState(false)
  const { getFlagComponent } = useFlagIcon()

  const handlePrev = () => {
    if (!sliderRef.current) {
      return
    }
    sliderRef.current.swiper.slidePrev()
  }

  const handleNext = () => {
    if (!sliderRef.current) {
      return
    }
    sliderRef.current.swiper.slideNext()
  }

  useEffect(() => {
    if (transaction && !selectedOffer) {
      setpickupRoutes(transaction.pickupRoutes)
      setdeliveryRoutes(transaction.deliveryRoutes)
      // setitem(transaction.matchedLoad || transaction.matchedTruck)
    }
  }, [transaction])

  useEffect(() => {
    if (showRouteOf) {
      setpickupRoutes(showRouteOf.pickupRoutes)
      setdeliveryRoutes(showRouteOf.deliveryRoutes)
      // setitem(showRouteOf.matchedLoad || showRouteOf.matchedTruck)
    } else {
      setpickupRoutes(transaction.pickupRoutes)
      setdeliveryRoutes(transaction.deliveryRoutes)
      // setitem(transaction.matchedLoad || transaction.matchedTruck)
    }
  }, [showRouteOf])

  useEffect(() => {
    if (selectedOffer) {
      const pickupRoutes = [selectedOffer?.routes?.pickupRoute, ...(selectedOffer?.routes?.pickupStops || [])]
      const deliveryRoutes = [selectedOffer?.routes?.deliveryRoute, ...(selectedOffer?.routes?.deliveryStops || [])]
      setpickupRoutes(pickupRoutes)
      setdeliveryRoutes(deliveryRoutes)
      // setitem({
      //   pickupStopCount: pickupRoutes.length,
      //   deliveryStopCount: deliveryRoutes.length
      // })
    }
  }, [selectedOffer])

  return (
    <>
      <Swiper
        ref={sliderRef}
        spaceBetween={20}
        slidesPerView={3}
        className="swiper tennders-pickup-delivery-stops bg-color-light-gray b-r-10 px-20 py-10"
      >
        {
          pickupRoutes?.map((stop, index) => (
            stop
              ? (
                <SwiperSlide
                  key={stop.id}
                  virtualIndex={index}
                  className="pt-10"
                >
                  <div className="text-14 bold">
                    {index === 0 ? t('transaction:pickupStop', { count: pickupRoutes?.length }) : <>&nbsp;</>}
                  </div>
                  <div className="d-flex row mt-10">
                    { (transaction?.pickupStopCount > 1 || transaction?.deliveryStopCount > 1) && <div className="step-no">{index + 1}</div>}
                    <div className={`flex-1${(transaction?.pickupStopCount > 1 || transaction?.deliveryStopCount > 1) ? ' pl-8' : ''}`}>
                      <p className="text-12 mb-4">
                        {getFlagComponent(stop.countryCode)}
                        <span className="d-flex">
                          {stop.label}
                          <br />
                          {stop.date?.f}
                        </span>
                      </p>
                      {stop.instructions && (
                        <GHref onClick={() => setselectedStop(stop)} className="italic text-12 btn-link d-flex align-center">
                          <IconSeeNote />
                          {' '}
                          <span>{t('transaction:seeNote')}</span>
                        </GHref>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ) : null
          ))
        }
        {
          deliveryRoutes?.map((stop, index) => (
            stop ? (
              <SwiperSlide
                key={stop.id}
                className="pt-10"
              >
                <div className="text-14 bold">
                  {index === 0 ? (
                    <>
                      {t('transaction:deliveryStop', { count: deliveryRoutes?.length })}
                    </>
                  ) : <>&nbsp;</>}
                </div>
                <div className="d-flex row mt-10">
                  { (transaction?.pickupStopCount > 1 || transaction?.deliveryStopCount > 1) && <div className="step-no">{index + 1}</div>}
                  <div className={`flex-1${(transaction?.pickupStopCount > 1 || transaction?.deliveryStopCount > 1) ? ' pl-8' : ''}`}>
                    <p className="text-12 mb-4">
                      {getFlagComponent(stop.countryCode)}
                      <span className="d-flex">
                        {stop.label}
                        <br />
                        {stop.date?.f}
                      </span>
                    </p>
                    {stop.instructions && (
                      <GHref onClick={() => setselectedStop(stop)} className="italic btn-link text-12 d-flex align-center">
                        <IconSeeNote />
                        <span>{t('transaction:seeNote')}</span>
                      </GHref>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ) : null
          ))
        }
        <div onClick={handlePrev} className="swiper-button-prev pickup-delivery-stops-prev" />
        <div onClick={handleNext} className="swiper-button-next pickup-delivery-stops-next" />
      </Swiper>
      <MRouteInstructions
        t={t}
        size={300}
        route={selectedStop}
        isOpen={selectedStop}
        close={() => setselectedStop(false)}
      />
    </>
  )
}
Route.displayName = 'SwiperSlide'

export default React.memo(Route)
